import {z} from 'zod';

export const SummaryContentStep = z.object({
  data: z.array(
    z.object({
      gradYear: z.number(),
      steps: z.array(
        z.object({
          stepOrder: z.number(),
          stepName: z.string(),
        }),
      ),
    }),
  ),
  reference: z.array(z.number()),
});

export const SummaryContentQuestion = z.object({
  data: z.array(
    z.object({
      step: z.string(),
      items: z.array(
        z.object({
          category: z.string(),
          questions: z.array(z.string()),
        }),
      ),
    }),
  ),
  reference: z.array(z.number()),
});

export const SummaryContentAdvice = z.object({
  data: z.array(
    z.object({
      category: z.string(),
      advices: z.array(z.string()),
    }),
  ),
  reference: z.array(z.number()),
});

export const SummaryContentThemaTexts = z.object({
  data: z.array(
    z.object({
      thema: z.string(),
      texts: z.array(z.string()),
    }),
  ),
  reference: z.array(z.number()),
});

export const SummaryContentGeneral = z.object({
  data: z.array(
    z.object({
      answers: z.array(z.string()),
    }),
  ),
  reference: z.array(z.number()),
});

export const SummaryContent = z.union([
  SummaryContentStep,
  SummaryContentQuestion,
  SummaryContentAdvice,
  SummaryContentThemaTexts,
  SummaryContentGeneral,
]);

export const SummarySchema = z.object({
  typeID: z.number(),
  typeName: z.string(),
  summary: z.string(),
});

export const ParsedSummarySchema = z.object({
  typeID: z.number(),
  typeName: z.string(),
  summary: SummaryContent,
});

export const ReportSummarySchema = z.object({
  companyID: z.number(),
  companyName: z.string(),
  logoURLs: z.object({
    '140x105': z.string(),
    '200x150': z.string(),
    '400x300': z.string(),
  }),
  description: z.string(),
  departmentID: z.number(),
  departmentName: z.string(),
  industryID: z.number(),
  industryName: z.string(),
  industryCategoryID: z.number(),
  industryCategoryName: z.string(),
  summaries: z.array(SummarySchema),
  followCount: z.number(),
  followed: z.boolean(),
});

export type ReportSummaryType = z.infer<typeof ReportSummarySchema>;

export const DepartmentsSchema = z.object({
  departments: z.array(
    z.object({
      departmentID: z.number(),
      departmentName: z.string(),
    }),
  ),
});

export const CompaniesSchema = z.object({
  companies: z.array(
    z.object({
      companyID: z.number(),
      companyName: z.string(),
    }),
  ),
});
